const getters = {
  username: state => state.user.username,
  name: state => state.user.name,
  isApp: state => state.app.isApp,
  keepAlive: state => state.app.keepAlive,
  facingMode: state => state.app.facingMode,
  cameraRP: state => state.app.cameraRP,
}
export default getters
